import { TimeQuestionConfig, TimeResponseState } from '@gripp/shared-logic';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';
import { TimeMessageTypeComponents } from './message/executionMessage';

export const TimeQuestionMessage: RoutineQuestionMessage<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionMessageProps<TimeQuestionConfig, TimeResponseState>
) => {
  const { question } = props;
  const TimeMessageType = TimeMessageTypeComponents[question.timeType];

  return <TimeMessageType {...props} />;
};
